module.exports = __webpack_public_path__ + "static/media/bi_regular_season_emblem_white.94acb34c.png";